import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled, { css } from 'styled-components';

export const AgentBox = styled.div<{ color?: string }>`
  background: ${(props) => props.theme.background};
  min-width: 280px;
  flex: 1;
  border-radius: 5px;
  overflow: hidden;
  max-width: 460px;
  margin: 0 auto;

  ${(props) =>
    props.color
      ? css`
          border: 3px solid ${props.color};
        `
      : css`
          border: 1px solid #dedede;
        `}
`;

export const AgentButtons = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AgentBoxHeader = styled.div<{ color?: string }>`
  width: 100%;
  background-color: ${(props) => (props.color ? props.color : 'transparent')};
  padding: ${(props) => (props.color ? '10px' : '20px 20px 0')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AgentBoxContent = styled.div`
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
`;

export const AgentExtraInfo = styled.div<{ show: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (${mobileXXLargeMax}) {
    margin-top: 30px;
    display: ${(props) => (props.show ? 'block' : 'none')};
  }
`;

export const AgentListItem = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

export const Divider = styled.div`
  width: calc(100% - 30px);
  margin: 15px 15px 0;
  background-color: ${({ theme }) => theme.keyline};
  height: 1px;
`;

export const IconBox = styled.div`
  min-width: 18px;
  margin: 2px 10px 0 0;
  display: flex;
  justify-content: center;
`;

export const ShowMoreDetails = styled.button<{ color: string; show?: boolean }>`
  width: 100%;
  padding: 15px 0;
  display: none;
  color: ${(props) => props.color || 'inherit'};
  text-decoration: underline;
  border-top: 2px dashed ${(props) => props.theme.keyline};
  font-size: 15px;

  @media (${mobileXXLargeMax}) {
    display: ${(props) => (props.show ? 'block' : 'none')};
  }
`;

export const Title = styled.h3`
  color: ${(props) => props.theme.textDark};
  font-size: 20px;
  text-align: center;
  margin-top: 15px;
  padding: 0 15px;
`;

export const AgentLogo = styled.img`
  display: block;
  max-width: 250px;
  max-height: 60px;
`;

export const AwardLogo = styled.img`
  max-width: 250px;
  max-height: 80px;
  margin-bottom: 15px;
`;

export const AgentText = styled.p`
  color: ${(props) => props.theme.textMid};
  font-size: 14px;
  text-align: center;
`;

export const LicenceWarning = styled(Link)`
  width: 20px;
  height: 20px;
  background-color: ${(props) => props.theme.primary};
  border-radius: 10px;
  display: inline-block;
  font-weight: bold;
  color: ${(props) => props.theme.white};
  margin-left: 5px;
`;
